import {
    DTOCardFormField,
} from 'app/types/form.types'

type SkyMindSyncType = {
    availableInSkyMind: boolean,
    skyMindId: number,
}

const getSkyMindSyncFields = (
    isSkyMindId: boolean,
    availableInSkyMind: boolean,
): DTOCardFormField<keyof SkyMindSyncType>[] => {
    return [{
        id: 'SkyMindSync',
        title: 'SkyMind Sync',
        fields: [
            {
                name: 'availableInSkyMind',
                componentName: 'Switch',
                disabled: isSkyMindId,
                labelKey: 'AVAILABLE_IN_SKYMIND',
            },
            {
                name: 'skyMindId',
                componentName: 'InputSingleline',
                disabled: !availableInSkyMind || isSkyMindId,
                labelKey: 'SKYMIND_ID',
            },
        ],
    }]
}

export default getSkyMindSyncFields
